<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage KBstarView"
  >
    <header-area />

    <div class="worksView topPosition" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">
              The beginning of a new mobile<br />
              financial platform
            </div>
            <div class="workSlogan mobile">
              The beginning of<br />a new mobile<br />
              financial platform
            </div>
            <div class="workTopDay">
              <p>KB스타뱅킹 앱 리뉴얼</p>
              <ul>
                <li>Mobile App</li>
                <li>2021.10.27</li>
              </ul>
            </div>
            <div class="workTopSns">
              <!-- <a href="https://www.kbstar.com/" target="_blank"
                class="siteAddr">https://www.kbstar.com/</a> -->
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/kbstar"
                    title="1등 금융 플랫폼을 향한 변화의 시작"
                    hashtags="플립커뮤니케이션즈,KB국민은행,KB스타뱅킹"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>

                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/kbstar"
                    title="1등 금융 플랫폼을 향한 변화의 시작"
                    hashtags="플립커뮤니케이션즈,KB국민은행,KB스타뱅킹"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt">
            <marquee-text :duration="15"
              >&nbsp;The beginning of a new mobile financial platform&nbsp;</marquee-text
            >
          </span>
          <img class="web" src="@/assets/images/works_view/kbstar/kbstar_visual.jpg" alt="" />
          <img class="mobile" src="@/assets/images/works_view/kbstar/kbstar_visual_m.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          그동안의 은행 앱들은 기존 인터넷 뱅킹 서비스를<br class="mobile" />
          모바일로 옮겨 놓은 수준으로 디바이스 특성에<br class="mobile" />
          맞는 서비스를 구현하기에는<br class="web" />
          역부족이었습니다.<br class="mobile" />
          이에 더해 계속해서 출시되는 상품과 서비스들이<br class="mobile" />
          별도 앱으로 제공되면서 고객들은 10여 개가<br class="mobile" />
          넘는 앱을<br class="web" />
          설치해야 하는 상황에 이르렀습니다.<br class="mobile" />
          그 사이 인터넷 전용 은행이 출범했고, 기존 은행들과 달리 첫 시작부터 모바일에 맞춰<br
            class="web"
          />
          군더더기 없는 서비스를 제공했습니다.
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <div class="kbConcept top">
          <div class="txtWrap">
            <div class="tit">
              이에 KB국민은행은<br class="mobile" />
              축적된 경험과 기술을 바탕으로<br class="web" /><br class="mobile" />
              모바일뱅킹 특성에 맞는 플랫폼을<br class="mobile" />
              만들고,<br class="web" />
              기존 서비스들을<br class="mobile" />
              새롭게 만들어가기 위한 개편을<br class="mobile" />
              진행했습니다.
            </div>
          </div>
        </div>

        <div class="kbConcept type1">
          <div class="workView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="smallTit">
                <span class="line">#1</span>
              </div>
              <div class="tit">처음, 시작!</div>
              <div class="txt">
                새로워진 New KB스타뱅킹에서는 로그인 시<br class="mobile" />
                가장 먼저 홈 화면을 만날 수 있습니다.<br class="web" /><br class="mobile" />
                기존의 홈 화면은 고객이 아닌 서비스 제공자의<br class="mobile" />
                입장에서 메뉴가 구성됐지만,<br class="web" /><br class="mobile" />
                개선된 홈 화면에서는 고객의 계좌 정보와 함께<br class="mobile" />
                맞춤메뉴, 추천 콘텐츠를 한눈에 볼 수 있습니다.
              </div>
            </div>
            <div
              class="imgBox bg-circle"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="imgWrap">
                <div class="imgBack"></div>
                <div class="imgFront"></div>
              </div>

              <div class="imgFront-info">
                <p>내 계좌 정보</p>
                <p>맞춤메뉴</p>
                <p>추천 콘텐츠</p>
              </div>
            </div>
          </div>
        </div>

        <div class="kbConcept type2">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="smallTit">
                <span class="line">#2</span>
              </div>
              <div class="tit">내 마음대로 구성하는 홈</div>
              <div class="txt">
                홈 화면에 표시되는 대표 계좌는 최대 5개까지<br class="mobile" />
                설정할 수 있으며, 예금뿐만 아니라 펀드,<br class="mobile" />
                퇴직연금 등의 계좌 역시 지정할 수 있습니다.<br class="web" /><br class="mobile" />
                오픈뱅킹 이용자의 경우 타 금융 기관의 계좌 역시<br class="mobile" />
                스타뱅킹 홈에서 조회할 수 있습니다.<br class="web" /><br class="mobile" />
                ‘맞춤메뉴’에서는 사용자 데이터 분석에 따른<br class="mobile" />
                추천 메뉴와 함께 KB금융그룹, 생활/혜택 탭에서<br class="mobile" />
                사용 빈도가 높은 메뉴가 표시됩니다.<br class="web" />
                이와 함께<br class="mobile" />
                데이터 분석을 통한 추천 이벤트와 증권, 부동산<br class="mobile" />
                등의 금융 콘텐츠를 제공합니다.<br class="web" /><br class="mobile" />
                아울러 대표계좌, 맞춤메뉴, 고객추천의 <br class="mobile" />3개 영역은 순서를 바꿀 수
                있어 가장 편리한<br class="mobile" />
                구성을 직접 선택할 수 있습니다.
              </div>
            </div>

            <div
              class="imgBox bg-circle"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="slideBox">
                <div class="imgPhoneoutter slide">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type2_01.png" alt="" />
                  <p>홈</p>
                  <div class="keywordWrap">
                    <div class="word"><p>펀드</p></div>
                    <div class="word"><p>예금</p></div>
                  </div>
                </div>
                <div class="sec1Slider swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        src="@/assets/images/works_view/kbstar/img_kb_type2_slide01.png"
                        alt=""
                      />
                    </div>
                    <div class="swiper-slide">
                      <img
                        src="@/assets/images/works_view/kbstar/img_kb_type2_slide02.png"
                        alt=""
                      />
                    </div>
                    <div class="swiper-slide">
                      <img
                        src="@/assets/images/works_view/kbstar/img_kb_type2_slide03.png"
                        alt=""
                      />
                    </div>
                    <div class="swiper-slide">
                      <img
                        src="@/assets/images/works_view/kbstar/img_kb_type2_slide04.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="imgWrap">
                <div class="imgPhoneoutter img01">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type2_02.png" alt="" />
                  <p>맞춤메뉴</p>
                </div>
                <div class="imgPhoneoutter img02">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type2_03.png" alt="" />
                  <p>마이메뉴 설정</p>
                </div>
                <div class="imgPhoneoutter img03">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type2_04.png" alt="" />
                  <p>추천 콘텐츠</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="kbConcept type3">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="smallTit">
                <span class="line">#3</span>
              </div>
              <div class="tit">안전하고 빠른 자동 로그인</div>
              <div class="txt">
                자동 로그인 기능을 도입해 더욱 쉽고 빠르게<br class="mobile" />
                서비스에 접근할 수 있습니다.<br class="web" /><br class="mobile" />
                보안 수준을 높이기 위해 KB 모바일 인증서<br class="mobile" />
                사용자에게만 제공되며,<br class="web" />
                해당 인증서는<br class="mobile" />
                스타뱅킹 앱에서 즉시 발급할 수 있어<br class="mobile" />
                편의성을 높였습니다.<br class="web" />
                KB 모바일 인증서는<br class="mobile" />
                KB금융그룹의 계열사뿐만 아니라<br class="mobile" />
                국세청 홈택스, 정부24, 국민건강보험 등<br class="web" />
                다양한<br class="mobile" />
                공공기관 로그인에도 사용할 수 있습니다.
              </div>
            </div>

            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="imgIco01">
                <img src="@/assets/images/works_view/kbstar/ico_kb_type3_01.png" alt="" />
              </div>
              <div class="imgIco02">
                <img src="@/assets/images/works_view/kbstar/ico_kb_type3_02.png" alt="" />
              </div>
              <div class="imgWrap">
                <div class="imgPhoneoutter img01">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type3_01.png" alt="" />
                </div>
                <div class="imgPhoneoutter img02">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type3_02.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="kbConcept type4">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="smallTit">
                <span class="line">#4</span>
              </div>
              <div class="tit">찾기 쉬운 메뉴 구성</div>
            </div>
          </div>

          <div class="imgBox">
            <div class="imgWrap">
              <ul>
                <li class="img01">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type4_01.png" alt="" />
                  <div class="imgDesc">
                    <p>뱅킹</p>
                  </div>
                </li>
                <li class="img02">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type4_02.png" alt="" />
                  <div class="imgDesc">
                    <p>KB금융그룹</p>
                  </div>
                </li>
                <li class="img03">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type4_03.png" alt="" />
                  <div class="imgDesc">
                    <p>생활/혜택</p>
                  </div>
                </li>
                <li class="img04">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type4_04.png" alt="" />
                  <div class="imgDesc">
                    <p>MY메뉴</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div
            class="bg-filter"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="txtWrap">
              <div class="txt">
                KB국민은행은 인터넷 은행과 달리 펀드, 대출,<br class="mobile" />
                퇴직연금 등의 다양한 금융 상품과 그에 따른<br class="mobile" />
                서비스를 보유하고 있습니다.<br class="web" /><br class="mobile" />
                방대한 상품과 관련 메뉴를 ‘뱅킹’, ‘KB금융그룹’,<br class="mobile" />
                ‘생활/혜택’으로 구분했습니다. 뱅킹 메뉴에서는<br class="mobile" />
                조회, 이체, 상품 가입 등 은행 업무를,<br class="web" /><br class="mobile" />
                KB금융그룹 메뉴에서는 각 계열사의<br class="mobile" />
                금융 서비스를 제공합니다.<br class="mobile" />
                생활/혜택 메뉴에서는 각종 이벤트 신청 및<br class="mobile" />
                제휴사 서비스를 이용할 수 있습니다.<br class="web" /><br class="mobile" />
                또한 자주 사용하는 메뉴를 직접 설정할 수 있는<br class="mobile" />
                ‘My 메뉴’에서는 최근 3개월간 자주 찾은 메뉴를<br class="mobile" />
                함께 제공합니다.<br class="web" />
                더불어 복잡했던 메뉴 구조를<br class="mobile" />
                모바일 환경에서도 쉽게 찾을 수 있도록 정리함과 동시에 메뉴 검색 기능을 도입했습니다.
              </div>
            </div>
          </div>
        </div>

        <div class="kbConcept type5">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="smallTit">
                <span class="line">#5</span>
              </div>
              <div class="tit">하나의 앱에서 거래부터 알림까지</div>
              <div class="txt">
                계열사 서비스의 조회만 가능했던 이전과 달리<br class="mobile" />
                추가 앱 설치 없이 주식 매매와 KB Pay 등의<br class="mobile" />
                거래 업무까지 가능하게 됐습니다.<br class="web" /><br class="mobile" />
                아울러 모바일 쿠폰, 실손 보험 빠른 청구 등<br class="mobile" />
                제휴 서비스 역시 KB스타뱅킹 앱에서<br class="mobile" />
                이용할 수 있습니다.<br class="web" />
                또한 별도 앱으로 제공되던<br class="mobile" />
                알림 서비스를 스타뱅킹 앱에 통합하고<br class="mobile" />
                신규 알림 콘텐츠를 추가해 170여 개의 알림<br class="mobile" />
                서비스를 받을 수 있습니다.
              </div>
            </div>

            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="imgWrap">
                <div class="imgPhoneoutter img01">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type5_01.png" alt="" />
                  <p>KB Pay</p>
                </div>
                <div class="imgPhoneoutter img02">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type5_02.png" alt="" />
                  <p>KB 금융그룹 홈</p>
                </div>
                <div class="imgPhoneoutter img03">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type5_03.png" alt="" />
                  <p>KB 증권</p>
                </div>
              </div>
            </div>
            <div class="appIco">
              <ul>
                <li><img src="@/assets/images/works_view/kbstar/ico_kb_type5_01.png" alt="" /></li>
                <li><img src="@/assets/images/works_view/kbstar/ico_kb_type5_02.png" alt="" /></li>
                <li><img src="@/assets/images/works_view/kbstar/ico_kb_type5_03.png" alt="" /></li>
                <li><img src="@/assets/images/works_view/kbstar/ico_kb_type5_04.png" alt="" /></li>
                <li><img src="@/assets/images/works_view/kbstar/ico_kb_type5_05.png" alt="" /></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="kbConcept type6">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="smallTit">
                <span class="line">#6</span>
              </div>
              <div class="tit">상품 가입은 끊김 없이</div>
              <div class="txt">
                금융상품에서는 ‘간편신규’, ‘가입진행중’,<br class="mobile" />
                ‘장바구니’와 같이 고객의 상품 가입 상태를<br class="mobile" />
                한눈에 보여줍니다.<br class="web" />
                오프라인 지점과<br class="mobile" />
                고객상담센터에서 시작된 상품 가입 프로세스가<br class="mobile" />
                모바일 앱에서도 끊김 없이 이어지며,<br class="web" /><br class="mobile" />
                서류 준비 등으로 인해 가입이 일시 중단되더라도 중단된 지점에서 다시 시작할 수
                있습니다.<br class="web" /><br class="mobile" />
                이와 함께 고객의 관심 상품을 등록하고 다시<br class="mobile" />
                찾을 수 있는 장바구니 기능을 함께 제공합니다.
              </div>
            </div>

            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="imgWrap">
                <div class="imgPhoneoutter img01">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type6_01.png" alt="" />
                  <div class="joinProcess">
                    <ul>
                      <li>
                        <em>0</em>
                        <p>간편신규</p>
                      </li>
                      <li>
                        <em>2</em>
                        <p>가입진행중</p>
                      </li>
                      <li>
                        <em>3</em>
                        <p>장바구니</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="imgPhoneoutter img02">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type6_02.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="kbConcept type7">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="smallTit">
                <span class="line">#7</span>
              </div>
              <div class="tit">한데 모아 보는 자산 관리</div>
              <div class="txt">
                마이데이터 시행에 발맞춰 여러 금융권에 산재한<br class="mobile" />
                데이터를 간편하게 볼 수 있는 ‘마이자산관리’를<br class="mobile" />
                신설했습니다.<br class="web" /><br class="mobile" />
                자산, 투자, 지출, 세테크, 은퇴로 구분해<br class="mobile" />
                유형별, 기관별로 자산 현황을 조회하고 한눈에<br class="mobile" />
                비교할 수 있습니다<br class="web" /><br class="mobile" />
                더불어 고객 연령과 보유 상품을 중심으로<br class="mobile" />
                자산관리 유형 및 거래 성향을 구분해 <br class="mobile" />이에 맞는 맞춤 상품과
                콘텐츠를 추천합니다.
              </div>
            </div>

            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="keywordWrap">
                <div class="word01"><p>자산</p></div>
                <div class="word02"><p>지출</p></div>
                <div class="word03"><p>투자</p></div>
                <div class="word04"><p>은퇴</p></div>
              </div>
              <div class="imgWrap">
                <div class="imgPhoneoutter">
                  <img src="@/assets/images/works_view/kbstar/img_kb_type7_01.png" alt="" />
                </div>
                <div class="bgType7"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-kiwoom' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">키움증권 웹서비스 리뉴얼</strong>
          <strong class="mobile">키움증권 <br />웹서비스 리뉴얼</strong>
        </div>

        <div class="engBg orangeLEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
      title: {
        inner: "KB스타뱅킹"
      }
    }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText,
    Lottie
  },
  data() {
    return {
      meta: {
        siteName: "KB국민은행 스타뱅킹 앱 | 플립커뮤니케이션즈",
        title: "KB국민은행 스타뱅킹 앱",
        desc:
          "KB국민은행은 기존 인터넷 뱅킹 서비스의 한계를 극복하고 모바일 특성에 맞춘 New KB스타뱅킹을 출시했습니다. 개편된 모바일뱅킹은 맞춤 홈화면, 자동로그인, 통합 알림 등 고객 편의성을 높였고, 마이데이터를 기반으로 하는 마이자산관리 등 신규 서비스를 제공합니다",
        keywords:
          "모바일 금융 플랫폼, 모바일뱅킹 서비스, KB스타뱅킹 앱, 모바일 금융 혁신, 자동 로그인 기능, 개인화된 홈 화면, 편리한 계좌 관리, 오픈뱅킹 서비스, 보안 강화 기능, 다양한 금융 콘텐츠, 사용자 경험 개선, 고객 맞춤 서비스, 효율적인 거래 프로세스, 마이데이터 자산 관리, 투자 및 금융 상품 추천",
        url: "https://www.pulip.com/works/KBstar",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    // vuejs Bicint
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/kbstar").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.sec1Slider1.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.sec1Slider1 = new window.Swiper(".sec1Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      initialSlide: 2,
      // loopAdditionalSlides: 4,
      // slidesOffsetBefore: 195,
      spaceBetween: 0,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
      // breakpoints: {
      //   751: {
      //     spaceBetween: 20
      //   },
      // }
    });
  }
};
</script>
